import './styleGlobal.css';

const ImportarNovoModalEmpresa = () => {
 
    return <div className="col-md-12" style={{ display: 'flex', border: '1px solid #ddd', borderRadius: '5px', padding: '10px'}}>
        <div className="col-md-6" style={{borderRight: '1px solid #ddd', margin: '0 10px', padding: '0 10px'}}>
            <div style={{display: 'flex'}}>
                <div className="col-md-8 importarNovoModal">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">CNPJ</label>
                    <input placeholder="00.000.000/0000-00" type="text" className="form-control" id="form-obrigacao-nome" />
                </div>
                <div className="col-md-4">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Data de Abertura</label>
                    <input placeholder="00/00/0000" type="text" className="form-control" id="form-obrigacao-nome" />
                </div>
            </div>
            <div className="col-md-12">
                <label htmlFor="form-obrigacao-nome" className="form-label required">Razão Social</label>
                <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" />
            </div>
            <div style={{display: 'flex'}}> 
                <div className="col-md-9 importarNovoModal">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Nome Fantasia</label>
                    <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" />
                </div>
                <div className="col-md-3">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Porte</label>
                    <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" style={{padding: '10px'}} />
                </div>
            </div>
            <div className="col-md-12">
                <label htmlFor="form-obrigacao-nome" className="form-label required">Código e Descrição da Atividade Principal</label>
                <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" />
            </div>
            <div className="col-md-12">
                <label htmlFor="form-obrigacao-nome" className="form-label required">Código e Descrição da Atividade Secundária</label>
                <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" />
            </div>
            <div style={{display: 'flex'}}>
                <div className="col-md-9 importarNovoModal">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Endereço</label>
                    <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" />
                </div>
                <div className="col-md-3">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Número</label>
                    <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" style={{padding: '10px'}}  />
                </div>
            </div>
            <div style={{display: 'flex'}}>
                <div className="col-md-9 importarNovoModal">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Complemento</label>
                    <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" />
                </div>
                <div className="col-md-3">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">CEP</label>
                    <input placeholder="00000-000" type="text" className="form-control" id="form-obrigacao-nome" style={{padding: '10px 0 10px 10px'}}  />
                </div>
            </div>
        </div>

        <div className="col-md-6">
            <div style={{display: 'flex'}}>
                <div className="col-md-5 importarNovoModal">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Bairro</label>
                    <input placeholder="00.000.000/0000-00" type="text" className="form-control" id="form-obrigacao-nome" />
                </div>
                <div className="col-md-4 importarNovoModal">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Munícipio </label>
                    <input placeholder="00/00/0000" type="text" className="form-control" id="form-obrigacao-nome" />
                </div>
                <div className="col-md-2">
                    <label htmlFor="form-mensagem-tipo" className="form-label required">UF</label>
                    <select style={{backgroundColor: 'white', padding: '10px 41px'}} disabled placeholder="Selecione" className="form-select" id="form-mensagem-tipo" >
                        <option></option>
                    </select>
                </div>
            </div>
            <div className="col-md-11">
                <label htmlFor="form-obrigacao-nome" className="form-label required">E-mail</label>
                <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" />
            </div>
            <div style={{display: 'flex'}}>
                <div className="col-md-6 importarNovoModal">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Telefone</label>
                    <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" />
                </div>
                <div className="col-md-5">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Telefone Adcional</label>
                    <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" />
                </div>
            </div>
            <div style={{display: 'flex'}}>
                <div className="col-md-8 importarNovoModal">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Situação Cadastral</label>
                    <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" />
                </div>
                <div className="col-md-3">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Data da Situação Cad.</label>
                    <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" />
                </div>
            </div>
            <div className="col-md-11">
                <label htmlFor="form-obrigacao-nome" className="form-label required">Motivo da Situação Cadastral</label>
                <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" />
            </div>
            <div style={{display: 'flex'}}>
                <div className="col-md-8 importarNovoModal">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Situação Especial</label>
                    <input placeholder="Digite Algo" type="text" className="form-control" id="form-obrigacao-nome" />
                </div>
                <div className="col-md-3">
                    <label htmlFor="form-obrigacao-nome" className="form-label required">Data da Situação Esp.</label>
                    <input placeholder="00000-000" type="text" className="form-control" id="form-obrigacao-nome" />
                </div>
            </div>
        </div>
    </div>
}

export default ImportarNovoModalEmpresa;